import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { AppService } from "src/app/core/services/app.service";
import { FocuslinkService } from "src/app/core/services/focuslink.service";
import { LocalDataStoreService } from "src/app/core/services/local-data-store.service";
import { CustomerVenueGroup } from "src/app/shared/models/CustomerVenueGroup.item";
import { CustomerVenueMarketingBlast } from "src/app/shared/models/CustomerVenueMarketingBlast.item";
import { MarketingBlast } from "src/app/shared/models/MarketingBlast.item";
import { MarketingTemplate } from "src/app/shared/models/MarketingTemplate.item";

@Component({
	selector: "app-blast-detail",
	templateUrl: "./blast-detail.component.html",
	styleUrls: ["../../../commandcenter.scss"],
})
export class BlastDetailComponent implements OnInit {
	@Input() blastList: MarketingBlast[];
	@Output() blastListChange = new EventEmitter<MarketingBlast[]>();

	@Input() blast: MarketingBlast;
	@Output() blastChange = new EventEmitter<MarketingBlast>();

	@Input() templateList: MarketingTemplate[];
	@Input() groupList: CustomerVenueGroup[];
	@Input() venueKey: number;

	blastLoaded: boolean = false;

	customerList: CustomerVenueMarketingBlast[];

	constructor(public app: AppService, private focuslink: FocuslinkService, private localStorage: LocalDataStoreService, private route: ActivatedRoute) {}

	ngOnInit(): void {
		if (!this.blast) {
			this.initFromRoute(this.route.snapshot.paramMap.get("blastKey"));
		} else {
			this.init();
		}
		this.app.loading(true);
	}

	async initFromRoute(blastKey: string) {
		const venue = await this.localStorage.get("venue");
		this.venueKey = venue.key;
		await this.templateGet();
		await this.groupGet();
		this.getBlast(blastKey);
	}

	async init() {
		this.getBlast();
	}

	async getBlast(blastKey?: string) {
		const resp = await this.focuslink.marketingBlastGetOne(this.venueKey, blastKey || this.blast.sk);
		this.app.loading(false);
		this.blast = new MarketingBlast(resp);
		this.blast.templateName = this.templateList.find((i) => i.sk === this.blast.templateKey).name;
		this.blast.blastGroup = this.groupList.filter((i) => this.blast.groupKeyList.includes(i.sk));

		this.customerList = [...this.blast.blastCustomers];
		this.blastLoaded = true;
		console.log(this.customerList);
	}

	async groupGet() {
		const resp = await this.focuslink.customerGroupsGet(this.venueKey);
		const updateGroupResults: string[] = [];
		this.groupList = resp.map((i) => new CustomerVenueGroup(i));
	}

	async templateGet() {
		const resp = await this.focuslink.marketingTemplateGetAll(this.venueKey);
		this.templateList = resp.map((i) => new MarketingTemplate(i));
	}
}
